import { is_automation_condition_ui } from 'src/types/AutomationConditionUI';
import { is_device_cond_ui, is_device_trigger_ui } from 'src/types/DeviceCondAndTriggerUI';
import { is_energy_exchange_ui } from 'src/types/EnergyExchangeConditionUI';
import { is_sunrise_sunset_condition_ui } from 'src/types/SunriseSunsetConditionUI';
import { is_time_based_cond } from 'src/types/TimeBasedConditionsUI';
import { is_weather_cond_ui } from 'src/types/WeatherConditionUI';
import { alarms } from 'src/stores/lists/scenes-derived';
import { get } from 'svelte/store';

import type { DeviceConditionUI } from 'src/types/DeviceCondAndTriggerUI';
import { is_math_condition_ui } from 'src/types/Scenes/MathConditionUI';
import { is_manual_execution_condition } from 'src/types/ScenesConditionsTypes';
import type { ISceneObj } from 'src/types/SceneType';

let when_info = { mode: 'add', type: 'or', main_ind: -1, sub_ind: -1 };
export let defaultDeviceCondition: DeviceConditionUI = {
	device: {
		id: '',
		channel: 0,
	},
	add_info_ind: undefined,
	input_index: undefined,
	cond_name: '',
	operator: '',
	value: '0',
	transform: undefined,
};

export const defaultSceneData = {
	when_info,
	selectedCondition: 1,
	extractPropsFromSelectedCond: {},
	_device_condition: { ...defaultDeviceCondition },
	devicePropsOptions: [],
	selectedDevice: {},
	selectedDeviceProp: {},
	components: [],
	_time_trigger_obj: {
		id: -1,
		value: -1,
		_gui_type: undefined,
	},
	active_condition: {
		cond_name: 'energy_exchange',
		operator: '',
		value: 0,
		exchange_market: '',
		character: '',
		minutes: 0,
	},
	_automation_condition: {
		scene_id: '',
		selected: false,
	},
	_sunrise_sunset_cond: {
		hours: 0,
		mins: 0,
		type: 'sunrise',
		beforeAfter: 'before',
		locid: '',
	},
	weatherCondition: {
		cond: '',
		value: '',
		op: '',
		locid: '',
		hours: 0,
		execution_type: 'once',
	},
	selectedWatchType: 'trigger',
	watchProp: {
		cond_type_id: 1,
		cond_type_name: 'once',
		valid_for_min: 0,
	},
	translated: undefined,
	isValid: false,
	validStepIndex: 0,
};

export const WHEN_WIZARD_STEPS_INDEXES = {
	CONDITION_STEP: 0,
	DEVICE_STEP: 1,
	DEVICE_PROPS_STEP: 2,
	WATH_PROP_AS_STEP: 3,
	TIME_BASED_STEP: 1,
	PREDICTION_PERIOD_STEP: 1,
	WEATHER_STEP: 2,
	CONDITION_TYPE_STEP: 3,
	TIME_STEP: 1,
	SELECT_SCENE_STEP: 1,
	EXCHANGE_STEP: 1,
	SELECT_ALARM_STEP: 1,
	MATH_EXPRESSION_STEP: 1,
};

// conditionType values are equal to defined object in ConditionStep select_card_condition_options.
// TODO Move select_card_condition_options here
export const getTranslationType = (condition, sceneData) => {
	let isValid = false;
	let isTranslation = false;
	let conditionType = undefined;

	if (is_device_trigger_ui(sceneData.translated) || is_device_cond_ui(sceneData.translated)) {
		isTranslation = true;
		conditionType = 1;
		isValid = condition === conditionType;
	} else if (is_time_based_cond(sceneData.translated)) {
		isTranslation = true;
		conditionType = 2;
		isValid = condition === conditionType;
	} else if (
		is_automation_condition_ui(sceneData.translated) &&
		get(alarms)[sceneData.translated.scene_id]
	) {
		isTranslation = true;
		conditionType = 7;
		isValid = condition === conditionType;
	} else if (is_automation_condition_ui(sceneData.translated)) {
		isTranslation = true;
		conditionType = 5;
		isValid = condition === conditionType;
	} else if (is_sunrise_sunset_condition_ui(sceneData.translated)) {
		isTranslation = true;
		conditionType = 4;
		isValid = condition === conditionType;
	} else if (is_weather_cond_ui(sceneData.translated)) {
		isTranslation = true;
		conditionType = 3;
		isValid = condition === conditionType;
	} else if (is_energy_exchange_ui(sceneData.translated)) {
		isTranslation = true;
		conditionType = 6;
		isValid = condition === conditionType;
	} else if (is_math_condition_ui(sceneData.translated)) {
		isTranslation = true;
		conditionType = 8;
		isValid = condition === conditionType;
	} else if (is_manual_execution_condition(sceneData.translated)) {
		isTranslation = true;
		conditionType = 9;
		isValid = condition === conditionType;
	}

	return { isValid, isTranslation, conditionType };
};

/**
 * Checks if the scene object has at least one manual execution condition.
 * It specifically looks into `if.or[...].and[...]` structure.
 * @param {ISceneObj} scene_object The scene object to check.
 * @returns {boolean} True if a manual execution condition is found, false otherwise.
 */
export const hasManualExecutionCondition = (scene_object: ISceneObj) => {
	return (
		scene_object?.if?.or?.some((orBlock) =>
			orBlock?.and?.some((andCondition) => andCondition?._gui_type === 'manual_execution'),
		) ?? false
	);
};
